export default __webpack_public_path__ + "static/media/Bingo-Games.7d1b50a6.png";